const constants = {
    ajax: {
        methods: {
            get: 'GET',
            post: 'POST'
        },
        baseUrl: 'https://king.yarillo.com',
        credentials: {
            include: 'include'
        }
    }
};

export default constants;